import React, { useEffect, useRef } from 'react';

function LoadMore({ hasMore, loading, onLoad }) {
  const ref = useRef(null);
  const onLoadRef = useRef(onLoad);
  onLoadRef.current = onLoad;

  useEffect(() => {
    const node = ref.current;
    if (!node || !hasMore || loading) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onLoadRef.current();
      },
      { rootMargin: '240px' }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMore, loading]);

  if (!hasMore && !loading) return null;
  return (
    <div ref={ref} className="py-3 text-center text-muted small">
      {loading ? 'Loading more…' : ''}
    </div>
  );
}

export default LoadMore;
